import { render, staticRenderFns } from "./NewsDetailViewCustomizerDialog.vue?vue&type=template&id=1bdd3f07"
import script from "./NewsDetailViewCustomizerDialog.js?vue&type=script&lang=js&external"
export * from "./NewsDetailViewCustomizerDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports